import React, {useMemo} from 'react';
import {Droppable} from 'react-beautiful-dnd';
import Item from './item';

const Column = ({
                    column,
                    items,
                    selected,
                    draggingId,
                    toggleSelection,
                    toggleSelectionInGroup,
                    multiSelectTo,
                    doubleClick,
                    t,
                    search,
                    index: ind,
                }) => {
    const selectedMap = useMemo(
        () => {
            return selected.map(item => item.id);
        },
        [selected],
    );

    return (
        <div className='drag-and-drop__column'>
            <p className='drag-and-drop__column-label'>{t(column.title)}</p>
            <Droppable droppableId={column.id}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        style={{
                            padding: 5,
                            width: '100%',
                            height: 'calc(55vh - 50px)',
                            minHeight: 200,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                        }}
                    >
                        {items.map((item, index) => {
                            const isSelected = selectedMap.includes(item.id);
                            const isGhosting =
                                isSelected && Boolean(draggingId) && draggingId !== item.id;
                            return (
                                <Item
                                    style2={ind === 1}
                                    item={item}
                                    index={index}
                                    key={item.id}
                                    isSelected={isSelected}
                                    isGhosting={isGhosting}
                                    isDragging={draggingId === item.id}
                                    t={t}
                                    droppableId={column.id}
                                    search={search}
                                    selectionCount={selected.length}
                                    toggleSelection={toggleSelection}
                                    toggleSelectionInGroup={toggleSelectionInGroup}
                                    multiSelectTo={multiSelectTo}
                                    doubleClick={doubleClick}
                                />
                            );
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    );
};

export default Column;



// WEBPACK FOOTER //
// ./App/components/DragAndDrop/column.jsx